import React, { Component } from "react";
import { connect } from "react-redux";
import TrinityConditionSubject from "../TrinityCondition/components/TrinityConditionSubject";
import TrinityConditionLevel from "../TrinityCondition/components/TrinityConditionLevel";
import TrinityConditionNext from "../TrinityCondition/components/TrinityConditionNext";
import TrinityConditionConfirm from "../TrinityCondition/components/TrinityConditionConfirm";
import { actions as trinityActions } from "../../../redux/modules/trinity";
import Line from "../../../components/Line";
import ErrorTip from "../../../components/ErrorTip";
import { post, get } from "../../../utils/request";
import { jumpUrl } from "../../../utils/tool.js";
import "./style.css";
let trinitySiv;
class TrinityCondition extends Component {
  componentWillMount() {
    this.requestShareConfig();
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    //requestUserInfo();
    this.requestUserTrinityCondition();
    this.requestIsBuy();
    document.title = "浙考之家-每日高升-三一报考大师";
  }
  render() {
    const {
      subjectCondition,
      levelCondition,
      uiState,
      statInfo,
      wholeSubject,
    } = this.props;
    return (
      <div style={{ overflow: "auto", height: 700 }}>
        <Line></Line>
        <TrinityConditionSubject
          subjectCondition={subjectCondition}
          handleChooseSubject={this.handleChooseSubject}
        ></TrinityConditionSubject>
        <Line></Line>
        <TrinityConditionLevel
          levelCondition={levelCondition}
          handleChooseLevel={this.handleChooseLevel}
        ></TrinityConditionLevel>
        <Line></Line>
        <TrinityConditionNext
          statInfo={statInfo}
          statInfoVisible={uiState.statInfoVisible}
          handleNext={this.handleNext}
        ></TrinityConditionNext>
        <ErrorTip
          visible={uiState.errorTipVisible}
          errorInfo={uiState.errorTip}
          handleCloseModal={this.handleCloseErrorTipModal}
        ></ErrorTip>
        <TrinityConditionConfirm
          statInfo={statInfo}
          subjectCondition={subjectCondition}
          close={this.handleCloseConfirm}
          visible={uiState.confirmVisible}
          wholeSubject={wholeSubject}
          time={uiState.time}
          handleConfirm={this.handleConfirm}
        ></TrinityConditionConfirm>
      </div>
    );
  }
  /**
   * 请求用户的三位一体精灵
   */
  requestUserTrinityCondition = () => {
    let subjectArray = [
      "语文",
      "数学",
      "外语",
      "政治",
      "历史",
      "地理",
      "物理",
      "化学",
      "生物",
      "技术",
    ];
    let statInfo = {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
    };
    const { dispatch } = this.props;
    get("/public/v1/trinity/condition").then((res) => {
      let LevelCondition = JSON.parse(JSON.stringify(res.data.subjectLevels));
      let SubjectCondition = JSON.parse(JSON.stringify(res.data.subjects));
      let PreLevelCondition = JSON.parse(
        JSON.stringify(res.data.subjectLevels)
      );
      let PreSubjectCondition = JSON.parse(JSON.stringify(res.data.subjects));
      for (let i = 0; i < subjectArray.length; i++) {
        if (LevelCondition[subjectArray[i]] !== "") {
          let tmp = statInfo[LevelCondition[subjectArray[i]]];
          statInfo[LevelCondition[subjectArray[i]]] = tmp + 1;
        }
      }
      dispatch(trinityActions.setStatInfo(statInfo));
      dispatch(trinityActions.setStatInfoVisible(true));
      dispatch(trinityActions.setLevelCondition(LevelCondition));
      dispatch(trinityActions.setSubjectCondition(SubjectCondition));
      dispatch(trinityActions.setPreLevelCondition(PreLevelCondition));
      dispatch(trinityActions.setPreSubjectCondition(PreSubjectCondition));
    });
  };

  /**
   * 打开条件确认框
   */
  handleOpenConfirm = () => {
    const { dispatch } = this.props;
    dispatch(trinityActions.setConfirmVisible(true));
    dispatch(trinityActions.setTime(5));
    let time = 5;
    trinitySiv = setInterval(() => {
      time = --time;
      if (time <= -1) {
        clearInterval(trinitySiv);
      }
      dispatch(trinityActions.setTime(time <= -1 ? 0 : time));
    }, 1000);
  };

  /**
   * 关闭条件确认框
   */
  handleCloseConfirm = () => {
    const { dispatch } = this.props;
    clearInterval(trinitySiv);
    dispatch(trinityActions.setTime(5));
    dispatch(trinityActions.setConfirmVisible(false));
  };

  /**
   * 确认用户三位一体的条件
   */
  handleConfirm = () => {
    const { dispatch } = this.props;
    let time = this.props.uiState.time;
    if (time <= 0) {
      let params = {
        subjects: this.props.subjectCondition,
        subjectLevels: this.props.levelCondition,
      };
      post("/public/v1/trinity/condition", params).then((res) => {
        dispatch(trinityActions.setConfirmVisible(false));
        this.props.history.push("/trinity/result");
      });
    }
  };
  /**
   * 关闭错误提示框
   */
  handleCloseErrorTipModal = () => {
    const { dispatch } = this.props;
    if (
      this.props.uiState.errorTip ===
      "当前修改次数已用完，次年三位一体招生章程公布后可继续修改。"
    ) {
      dispatch(trinityActions.setErrorTip(false, ""));
      this.props.history.push("/trinity/result");
    } else {
      dispatch(trinityActions.setErrorTip(false, ""));
    }
  };

  /**
   * 选择选考科目
   * @param {科目} subject
   * @param {级别} level
   */
  handleChooseLevel = (subject, level) => {
    const { dispatch } = this.props;
    let levelCondition = this.props.levelCondition;
    if (levelCondition[subject] === level) {
      levelCondition[subject] = "";
    } else {
      levelCondition[subject] = level;
    }
    dispatch(trinityActions.setLevelCondition(levelCondition));
    this.handleStatInfo();
  };
  /**
   * 选择选考科目
   * @param {选考科目} subject
   */
  handleChooseSubject = (subject) => {
    const { dispatch } = this.props;
    let subjectArray = this.props.subjectCondition;
    if (
      this.handleSubjectErrorTip(subjectArray, subject) ||
      subjectArray.includes(subject)
    ) {
      if (subjectArray.includes(subject)) {
        subjectArray.splice(
          subjectArray.findIndex((item) => item === subject),
          1
        );
      } else {
        subjectArray.push(subject);
      }
      dispatch(trinityActions.setSubjectCondition(subjectArray));
    }
  };
  /**
   * 控制错误的弹出框显示和关闭
   */
  handleSubjectErrorTip = (subjectArray, subject) => {
    const { dispatch } = this.props;
    if (subjectArray.length >= 3 && !subjectArray.includes(subject)) {
      dispatch(trinityActions.setErrorTip(true, "请先取消一科"));
      return false;
    }
    return true;
  };
  /**
   * 下一步操作
   */
  handleNext = () => {
    const { dispatch } = this.props;
    let subjectArray = this.props.subjectCondition;
    let levelCondition = this.props.levelCondition;
    let statInfo = this.props.statInfo;
    if (subjectArray.length < 3) {
      dispatch(trinityActions.setErrorTip(true, "选考科目必选三项"));
      return;
    }
    if (
      levelCondition["语文"] === "" ||
      levelCondition["数学"] === "" ||
      levelCondition["外语"] === "" ||
      levelCondition["政治"] === "" ||
      levelCondition["历史"] === "" ||
      levelCondition["地理"] === "" ||
      levelCondition["物理"] === "" ||
      levelCondition["化学"] === "" ||
      levelCondition["生物"] === "" ||
      levelCondition["技术"] === ""
    ) {
      dispatch(trinityActions.setErrorTip(true, "学考还有科目未选"));
      return;
    }
    if (statInfo["E"] >= 1) {
      dispatch(
        trinityActions.setErrorTip(true, "学考科目有E等级，无法参加三位一体")
      );
      return;
    }
    // 首先判断一下该用户还有几次可以使用，如果没有次数可以用了 弹出没有次数的提示框
    get("/public/v1/trinity/user/times").then((res) => {
      let data = res.data;
      let flag = this.checkTrinityConditionChange(); // 判断一下是否已经数据是否更改了 如果没有更改，不需要弹出确认框
      if (data.times > 0) {
        if (flag) {
          this.handleOpenConfirm();
        } else {
          this.props.history.push("/trinity/result");
        }
      } else {
        if (flag) {
          dispatch(
            trinityActions.setErrorTip(
              true,
              "当前修改次数已用完，次年三位一体招生章程公布后可继续修改。"
            )
          );
        } else {
          this.props.history.push("/trinity/result");
        }
      }
    });
  };
  /**
   * 判断三位一体条件是否被修改
   */
  checkTrinityConditionChange = () => {
    let subjectArray = this.props.subjectCondition;
    let levelCondition = this.props.levelCondition;
    let preSubjectArray = this.props.preSubjectCondition;
    let preLevelCondition = this.props.preLevelCondition;
    for (let i = 0; i < subjectArray.length; i++) {
      let flag = preSubjectArray.includes(subjectArray[i]);
      if (flag === false) {
        return true;
      }
    }
    if (
      levelCondition["语文"] !== preLevelCondition["语文"] ||
      levelCondition["数学"] !== preLevelCondition["数学"] ||
      levelCondition["外语"] !== preLevelCondition["外语"] ||
      levelCondition["政治"] !== preLevelCondition["政治"] ||
      levelCondition["历史"] !== preLevelCondition["历史"] ||
      levelCondition["地理"] !== preLevelCondition["地理"] ||
      levelCondition["物理"] !== preLevelCondition["物理"] ||
      levelCondition["化学"] !== preLevelCondition["化学"] ||
      levelCondition["生物"] !== preLevelCondition["生物"] ||
      levelCondition["技术"] !== preLevelCondition["技术"]
    ) {
      return true;
    }
    return false;
  };
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-每日高升-三一报考大师", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-每日高升-三一报考大师", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };

  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };

  /**
   * 统计学考等级信息
   */
  handleStatInfo = () => {
    const { dispatch } = this.props;
    let levelCondition = this.props.levelCondition;
    let statInfo = this.props.statInfo;
    let subjectArray = [
      "语文",
      "数学",
      "外语",
      "政治",
      "历史",
      "地理",
      "物理",
      "化学",
      "生物",
      "技术",
    ];
    statInfo = {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
    };
    dispatch(trinityActions.setStatInfo(statInfo));
    if (
      levelCondition["语文"] === "" &&
      levelCondition["数学"] === "" &&
      levelCondition["外语"] === "" &&
      levelCondition["政治"] === "" &&
      levelCondition["历史"] === "" &&
      levelCondition["地理"] === "" &&
      levelCondition["物理"] === "" &&
      levelCondition["化学"] === "" &&
      levelCondition["生物"] === "" &&
      levelCondition["技术"] === ""
    ) {
      dispatch(trinityActions.setStatInfoVisible(false));
    } else {
      for (let i = 0; i < subjectArray.length; i++) {
        if (levelCondition[subjectArray[i]] !== "") {
          let tmp = statInfo[levelCondition[subjectArray[i]]];
          statInfo[levelCondition[subjectArray[i]]] = tmp + 1;
        }
      }
      dispatch(trinityActions.setStatInfo(statInfo));
      dispatch(trinityActions.setStatInfoVisible(true));
    }
  };
}
const mapStateToProps = (state) => {
  //console.log(state.trinity.trinityData);
  //console.log(state.trinity.trinityUiData);
  return {
    subjectCondition: state.trinity.trinityData.subjectCondition,
    levelCondition: state.trinity.trinityData.levelCondition,
    preSubjectCondition: state.trinity.trinityData.preSubjectCondition,
    preLevelCondition: state.trinity.trinityData.preLevelCondition,
    wholeSubject: state.trinity.trinityData.wholeSubject,
    statInfo: state.trinity.trinityData.statInfo,
    uiState: state.trinity.trinityUiData,
  };
};
export default connect(mapStateToProps)(TrinityCondition);



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityCondition/index.js